export const GRID_PAGE_SIZE_LIST: number[] = [10, 20, 30];

export const GRID_PAGE_DEFAULT_SIZE: number = GRID_PAGE_SIZE_LIST[0];
